module.exports = __webpack_public_path__ + "static/img/fascist-victory.b04aded.png";


//////////////////
// WEBPACK FOOTER
// ./src.common/assets/misc/fascist-victory.png
// module id = 259
// module chunks = 0